import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { Sparkles } from "lucide-react";

const labels = {
  fr: { tag: "Ce mois-ci", title: "La lumière", title2: "en action.", collected: "Collectés ce mois", donors: "Donateurs anonymes", empty: "Soyez le premier à contribuer ce mois-ci." },
  en: { tag: "This month", title: "The light", title2: "in action.", collected: "Raised this month", donors: "Anonymous donors", empty: "Be the first to give this month." },
  de: { tag: "Diesen Monat", title: "Das Licht", title2: "in Aktion.", collected: "Diesen Monat gesammelt", donors: "Anonyme Spender", empty: "Seien Sie diesen Monat der·die Erste." },
};

export default function MonthlyDonationsCounter() {
  const { lang } = useI18n();
  const [data, setData] = useState({ month_total: 0, month_count: 0 });
  useEffect(() => { api.get("/stats/monthly-donations").then(r => setData(r.data)).catch(() => {}); }, []);
  const m = labels[lang] || labels.fr;
  return (
    <section className="py-12 bg-deep-blue text-ivory" data-testid="monthly-counter">
      <div className="max-w-6xl mx-auto px-5 lg:px-10 grid md:grid-cols-3 gap-6 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-gold/20 border border-gold/40 text-gold text-xs uppercase tracking-widest">
            <Sparkles size={12}/> {m.tag}
          </div>
          <h2 className="font-display text-4xl mt-3">{m.title}<br/><span className="italic text-gold">{m.title2}</span></h2>
        </div>
        <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center">
          <div className="font-display text-5xl text-gold" data-testid="month-total">{data.month_total.toLocaleString("fr-FR")} €</div>
          <div className="text-ivory/70 mt-2 text-sm">{m.collected}</div>
        </div>
        <div className="p-6 rounded-2xl bg-white/5 border border-white/10 text-center">
          <div className="font-display text-5xl text-gold" data-testid="month-count">{data.month_count}</div>
          <div className="text-ivory/70 mt-2 text-sm">{m.donors}</div>
        </div>
        {data.month_count === 0 && <p className="md:col-span-3 text-center text-ivory/60 italic text-sm">{m.empty}</p>}
      </div>
    </section>
  );
}
